import React, { ReactElement } from 'react';

const ModuleLoading = (): ReactElement => <div style={{ minHeight: 300 }} />;

export default ModuleLoading;
